import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { about, foodGallery, mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromotion} w="90%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <CFImage src={promotions} w="100%" alt="Promotions" />
          <CFImage src={about} w="100%" alt="Promotions" />
          <CFImage src={foodGallery} w="100%" alt="Promotions" mt="-1px" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
